import { createAction } from '../../models/redux/CreateAction';
import * as types from './types';

export const fetchRecentRoutes = (id: number, filter = {}) => {
  return createAction(types.RECENT_ROUTES_GET_REQUEST, { id: id, filter: filter });
};

export const fetchRouteTemplates = (id: number, filter = {}) => {
  return createAction(types.ROUTE_TEMPLATES_GET_REQUEST, { id: id, filter: filter });
};

export const fetchActualRoutes = () => {
  return createAction(types.ACTUAL_ROUTES_GET_REQUEST);
};

export const fetchActualDepotRoutes = () => {
  return createAction(types.ACTUAL_DEPOT_ROUTES_GET_REQUEST);
};

export const swapIndexes = (a: number, b: number, routeIndex: number) => ({
  type: types.SWAP_INDEXES,
  payload: { a, b, routeIndex }
});

export const fetchRouteDeclarationFormInformation = () => {
  return createAction(types.ROUTE_DECLARATION_FORM_INFORMATION_GET_REQUEST);
};
